module.exports = require('./dist/reducers');
